/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

//import { HtmlHeadInclude } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import { IAbsoluteScriptViewProps } from './absolute-script';

export default (props: IAbsoluteScriptViewProps) => {
    const { 
        scriptFull
    } = props;

    return (
       
        <noscript dangerouslySetInnerHTML={{ __html: scriptFull}} />
        
    );
};

